import * as React from 'react';

export const clFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_480)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_480'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_480)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 10.6667H28V20H0V10.6667Z'
                    fill='#DA291C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H12V10.6667H0V0Z'
                    fill='#0032A0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.0001 6.96935L4.0401 8.00002L4.41343 5.81868L2.82943 4.27202L5.0201 3.95468L6.0001 1.96802L6.9801 3.95468L9.17076 4.27468L7.5841 5.81868L7.9601 8.00002'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_480'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
